import { c as _c } from "react/compiler-runtime";
import { theme } from '@cc-shopping/ui/theme';
import { useMediaQuery } from '@mui/material';
import { forwardRef } from 'react';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { StickyHeaderContainer } from './StickyHeader.container';
import { StickyHeaderImpressionWrapper } from './StickyHeaderImpressionWrapper';
export function StickyHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StickyHeaderContainer><StickyHeaderImpressionWrapper><Content /></StickyHeaderImpressionWrapper></StickyHeaderContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
const Content = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const $ = _c(12);
  const {
    analytics
  } = useCreditCardCompareOfferContext();
  let t0;
  if ($[0] !== analytics.section) {
    t0 = {
      ...analytics.section,
      name: "cc_shopping_product_card_sticky"
    };
    $[0] = analytics.section;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== analytics.marketplacePayload) {
    t1 = {
      ...analytics.marketplacePayload,
      section_name: "cc_shopping_product_card_sticky"
    };
    $[2] = analytics.marketplacePayload;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      section: t0,
      marketplacePayload: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const updatedAnalytics = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = theme.breakpoints.down("md");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isMobile = useMediaQuery(t3);
  let t4;
  if ($[8] !== isMobile || $[9] !== ref || $[10] !== updatedAnalytics) {
    t4 = !isMobile ? <Desktop innerRef={ref} updatedAnalytics={updatedAnalytics} /> : <Mobile innerRef={ref} updatedAnalytics={updatedAnalytics} />;
    $[8] = isMobile;
    $[9] = ref;
    $[10] = updatedAnalytics;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});